import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid } from '@mui/material';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import CommonTable from 'components/commonTable/CommonTable';
import CommonDialog from 'components/commonDialog/CommonDialog';
import { deleteCar, getCar, getFacilities, patchUpdateCar, postAddCar } from 'redux/actions/UserCar';
import Loader from 'components/loader/Loader';
import { cabDetails } from './DataAddCab';

function AddCabView() {

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [carData, setCarData] = useState({});
  const [type, setType] = useState('Create');
  const [defaultValue, setDefaultValue] = useState({})
  const [selectedImage, setSelectedImage] = useState('')
  const carList = useSelector((state) => state?.userCar?.userCar?.data)
  const vehicleLoader = useSelector((state) => state?.userCar?.loading);
  const faciliesList = useSelector((state) => state?.userFacilities?.userFacilities?.data)

  useEffect(() => {
    dispatch(getCar());
    dispatch(getFacilities());
  }, []);

  const breadcrumbPaths = [
    { name: 'Vehicle Category', url: '', className: 'colorBlue' },
  ];

  const onClickMoreIcon = (data, typeVal) => {
    setCarData(data)
    if(typeVal === 'Delete'){
      const val = {
        carId: data.id
      }
      dispatch(deleteCar(val))
    }else if(typeVal === 'Activate'){
      const val = {
        status:'Active',
        carId: data.id
      }
      dispatch(patchUpdateCar(val))
    }else if(typeVal === 'Deactivate'){
      const val = {
        status:'InActive',
        carId: data.id
      }
      dispatch(patchUpdateCar(val))
    }else {
      const value = {
        "category":data?.carType,
        "customerSeat":data?.seater,
        "facilities":data?.Facilities,
        "avtar":data?.avtar,
      }
      setDefaultValue(value)
      setType(typeVal)
      setOpen(true);
    }
  }
const onImageHandleChange =(data) =>{
  setSelectedImage(data);
}
const payloadData = (data,type) =>{
  let formData = new FormData();
  formData.append("carType",data?.category);
  formData.append("AC",true);
  formData.append( "avtar",selectedImage);
  formData.append( "seater",data?.customerSeat);
  if(type?.toLowerCase() === 'edit'){
    formData.append("carId",carData?.id)
  }
 if (Array.isArray(data?.facilities)) {
  data?.facilities?.forEach(facilityId => {
      formData.append('facilityIds[]', facilityId);
  });
}
return formData
}
  const onDialog = (data, code) => {
   
    if(type?.toLowerCase() === 'edit'){
      dispatch(patchUpdateCar( payloadData(data,type)));
    }else{
      dispatch(postAddCar( payloadData(data)));
    }
    setOpen(false);
  };

  const handleOpenDialog = () => {
    setType('Create')
    setOpen(true);
    setDefaultValue({})
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className='marginBlock10'
      >
        <Grid item>
          <CommonBreadCrumb paths={breadcrumbPaths} />
        </Grid>
        <Grid item>
          <Button className="configaddBtn" onClick={handleOpenDialog}>Vehicle Category +</Button>
        </Grid>
      </Grid>
      {vehicleLoader ?
       <Loader /> :
      <CommonTable 
        data={carList} 
        onClickMoreIcon={onClickMoreIcon}
        tabName={'cabCategory'}
        isClickable = {false}
      />}

      {open ? <CommonDialog className='marginbottom20'
        open={open}
        handleClose={() => setOpen(false)}
        formData={cabDetails(carData)}
        button={'dialogButton'}
        onSubmittBtn={onDialog}
        selectType={type?.toLowerCase() === 'edit' ? 'edit' : 'Create'}
        type={type?.toLowerCase() === 'edit' ? ("Edit Vehicle Category ") : 'Vehicle Category'}
        defaultValues={defaultValue}
        optionData={faciliesList}
        onImageHandleChange={onImageHandleChange}
        />: null} 
    </div>
  );
}

export default AddCabView;